import React from 'react'

// import { Container, Draggable } from 'react-smooth-dnd';

import moment from 'moment'

import { _postConvertToHoldingList } from '../../services'

import './index.css'

import {
    Modal,
    List,
    Row,
    Col,
    InputNumber,
    Select,
    message
} from 'antd'

const { Option } = Select

class EnquiryModal extends React.Component{

    render(){

        const { productOrders } = this.props

        return(
            <Modal
                title="Convert to Holding List"
                onOk={this.handleOk}
                okButtonProps={{disabled: this.state.loading}}
                width={500}
                onCancel={this.props.closeModal}
                visible={true}
            >
                <div>
                    {productOrders  &&
                    <List
                        dataSource={productOrders}
                        renderItem={_productOrder => this.renderProductOrder(_productOrder)}
                        />
                    }
                    {/* <Container 
                    getChildPayload={this.getChildPayload}
                    onDrop={this.onDrop}>
                    {productOrders && productOrders.map( _productOrder => {
                        return (
                        <Draggable key={_productOrder.product.id}>
                            {this.renderProductOrder(_productOrder)}
                        </Draggable>
                        );
                    })}
                    </Container> */}
                </div>
            </Modal>
        )
    } 

    constructor(props){
        super(props)

        this.state = {
            loading: false
        }
    }


    // getChildPayload = (index) => {

    //     const { productOrders } = this.props

    //     console.log(productOrders[index])

    //     return productOrders[index]
    // }

    handleOk = () =>{

        const { enquirer, productOrders, dateEnquired } = this.props

        this.setState({ loading: true})

        console.log(`Enquiry from ${enquirer} ${moment(dateEnquired).format("LLLL")}`)

        _postConvertToHoldingList({
            name: `Enquiry from ${enquirer} ${moment(dateEnquired).format("LLLL")}`,
            productOrders
        })
        .then( res => {
            message.success("Successfully converted enquiry!")

            let enquiryIds = productOrders.map( _productOrder => _productOrder.enquiryId)

            this.props.recursiveCloseEnquiries(enquiryIds, 0)
            this.setState({loading: false})

            this.props.closeModal()
            // this.props.getOpenEnquiries()

        })  
        .catch( err => message.error("Error!"))

    }  

    // onDrop = (e) => {

    //     const { removedIndex, addedIndex } = e
    //     const { productOrders, setProductOrders } = this.props
        
    //     let _productOrders = [...productOrders]

    //     let temp = _productOrders[removedIndex]
    //     _productOrders[removedIndex] = _productOrders[addedIndex]
    //     _productOrders[addedIndex] = temp

    //     setProductOrders(_productOrders)

    // }

    // recursiveCloseEnquiries = (enquiryIds, i) =>{

    //     _postCloseEnquiry(enquiryIds[i])

    //     if(i === enquiryIds.length-1){
    //         message.success("Closed all enquiries!")
    //         return;
    //     } else {
    //         this.recursiveCloseEnquiries(enquiryIds, i+1)
    //     }

    // }


    renderProductOrder = (productOrder) =>{

        const { product, variants, quantity, enquiryId } = productOrder
        const { title, images } = product

        return (
            <Row  
                type="flex" 
                align="middle"
                justify="space-between"
                style={{marginBottom:8}}
                gutter={4}>
                <Col span={6}>
                    <div className='image-icon'>
                    <img 
                    alt="product"
                    src={images[0].url}/>
                    </div>
                </Col>
                <Col span={12}>
                    <Row style={{marginBottom: 4, fontWeight:600}}>
                        {title}
                    </Row>
                    <Row type="flex">
                        {this.renderVariants({
                            enquiryId: enquiryId,
                            availableVariants: product.variants, 
                            selectedVariant: variants
                        } )}
                    </Row>
                </Col>
                <Col span={6}>
                    {/* <span style={{marginRight: 8}}>Qty:</span> */}
                    <InputNumber
                        width={75}
                        onChange={(value)=>this.props.handleQuantityChange(value, enquiryId)}
                        value={quantity}
                    />
                </Col>
            </Row>
        )
    }

    renderVariants= ({enquiryId, availableVariants, selectedVariant})=>{
        
        if(availableVariants.length > 0){
            return(
            <div>
                {availableVariants.map( (_variant, index) => 
                    <Row>
                        <span style={{marginRight: 4}}>{_variant.name}:</span>
                        <Select
                            size='small'
                            onChange={(value) =>this.props.handleVariantChange({name: _variant.name, set: value, enquiryId})}
                            defaultValue={selectedVariant[index]._set}
                        >
                            {_variant._set.map( _set => 
                                <Option value={_set.name}>
                                    {_set.name}
                                </Option>
                            )}
                        </Select>
                    </Row>
                )}
            </div>
            )
        }
    }
}

export default EnquiryModal


// WEBPACK FOOTER //
// ./src/components/enquiry/modal.js